const BLOCK = 'LStudio__app_screen';

/*
    🔥 ESTADO DE PANTALLA — LA BASE DE TODOS LOS DEMÁS

    404, 403, error, mantenimiento y "sin datos" son la MISMA pantalla
    con distinto ícono, código y texto. Escribirlas por separado las
    condena a divergir: una queda centrada, otra no; una tiene botón de
    volver, otra no.

    Acá vive la forma. Los archivos hermanos solo eligen el contenido.

    ⚠️ isFullScreen

    false -> ocupa el hueco donde esté (dentro del layout, con header
             y sidebar visibles). Es lo correcto para un 403 o un
             "sin resultados": el usuario sigue navegando.

    true  -> tapa la ventana entera. Solo para mantenimiento o para un
             error del que no se puede seguir: si el shell mismo está
             roto, dejarlo a la vista es mentir.
*/

export const ScreenState = ({
    icon = null,
    code = null,                 // '404' | '403' | null
    title,
    description = null,
    actions = null,
    tone = 'neutral',            // neutral | accent | ok | warn | danger
    size = 'md',                 // sm | md | lg
    isFullScreen = false,
    children = null,
}) => (

    <section
        className={BLOCK}
        data-tone={tone}
        data-size={size}
        data-fullscreen={isFullScreen}
        role={tone === 'danger' ? 'alert' : 'status'}
        aria-live="polite"
    >

        <div className={`${BLOCK}__inner`}>

            {icon && <span className={`${BLOCK}__icon`} aria-hidden="true">{icon}</span>}

            {code && <p className={`${BLOCK}__code`}>{code}</p>}

            <h2 className={`${BLOCK}__title`}>{title}</h2>

            {description && <p className={`${BLOCK}__text`}>{description}</p>}

            {children && <div className={`${BLOCK}__slot`}>{children}</div>}

            {actions && <div className={`${BLOCK}__actions`}>{actions}</div>}

        </div>

    </section>
);
